export function dataEngineOptions(code, raw = {}) {
  if (code === 'jeddah_inquiry') {
    const error = message => { throw Object.assign(new Error(message), {code:'INVALID_ENGINE_OPTIONS',status:422}); };
    if (raw.executionTarget && raw.executionTarget !== 'local') error('استعلام أمانة جدة متاح على الجهاز المحلي فقط.');
    const inquiryMode = raw.inquiryMode || 'inquiry';
    if (!['inquiry','audit'].includes(inquiryMode)) error('اختر الاستعلام أو فحص المدخلات دون اتصال.');
    const result = {inquiryMode,executionTarget:'local',sheetName:String(raw.sheetName || '').trim()};
    if (result.sheetName.length > 31) error('اسم ورقة Excel أطول من الحد المسموح.');
    for (const [field,initial,min,max] of [['browserCount',1,1,2],['pagesPerBrowser',1,1,2],['testLimit',3,1,10],['manualTimeoutSeconds',1800,60,1800],['headerRow',0,0,100]]) {
      if (typeof raw[field] === 'boolean') error('إعداد الاستعلام غير صالح.');
      result[field] = Number(raw[field] ?? initial);
      if (!Number.isInteger(result[field]) || result[field] < min || result[field] > max) error('إعداد الاستعلام خارج الحد المسموح.');
    }
    return result;
  }
  if (code === 'jeddah_municipality') {
    const error = message => { throw Object.assign(new Error(message), {code:'INVALID_ENGINE_OPTIONS',status:422}); };
    const jeddahMode = raw.jeddahMode || 'audit';
    if (!['audit','test','followup','submit'].includes(jeddahMode)) error('اختر وضع فحص أو اختبار أو متابعة أو إرسال.');
    if (raw.executionTarget && raw.executionTarget !== 'local') error('محرك أمانة جدة متاح على الجهاز المحلي فقط.');
    const result = {jeddahMode,executionTarget:'local',sheetName:String(raw.sheetName || '').trim().slice(0,31),attachmentTitle:String(raw.attachmentTitle || 'مرفقات الاعتراض').trim()};
    if (result.attachmentTitle.length > 120 || /[<>:"/\\|?*\x00-\x1f]/.test(result.attachmentTitle)) error('عنوان المرفق غير صالح؛ حد العنوان 120 حرفًا.');
    result.attachmentSource = String(raw.attachmentSource || '').trim();
    if (result.attachmentSource.length > 1000 || /[\x00-\x1f]/.test(result.attachmentSource)) error('مسار مصدر المرفقات غير صالح.');
    for (const [field,max] of [['headerRow',100],['paymentColumn',16384],['textColumn',16384],['objectionColumn',16384],['attachmentColumn',16384],['violationColumn',16384]]) {
      result[field] = Number(raw[field] || 0);
      if (!Number.isInteger(result[field]) || result[field] < 0 || result[field] > max) error('صف العناوين أو ربط أعمدة المصدر غير صالح.');
    }
    const columns = ['paymentColumn','textColumn','objectionColumn','attachmentColumn','violationColumn'].map(field=>result[field]).filter(Boolean);
    if (new Set(columns).size !== columns.length) error('لا يمكن ربط حقلين بنفس عمود المصدر.');
    result.testLimit = Number(raw.testLimit ?? 1);
    if (!Number.isInteger(result.testLimit) || result.testLimit < 1 || result.testLimit > 3) error('الاختبار يقبل من اعتراض واحد إلى ثلاثة دون إرسال.');
    if (jeddahMode === 'submit') {
      result.submissionReason = String(raw.submissionReason || '').trim();
      if (raw.confirmSubmission !== true || result.submissionReason.length < 5 || result.submissionReason.length > 1000) error('الإرسال الفعلي يتطلب التأكيد وبيان أساس الاعتماد.');
      result.confirmSubmission = true;
    }
    return result;
  }
  if (code === 'moeen_screenshots') {
    const captureMode = raw.captureMode || 'documentation';
    if (!['documentation','execution'].includes(captureMode)) throw Object.assign(new Error('اختر وضع التوثيق أو التنفيذ.'),{code:'INVALID_ENGINE_OPTIONS',status:422});
    if (raw.executionTarget && raw.executionTarget !== 'local') throw Object.assign(new Error('محرك الصور متاح محليًا حاليًا.'),{code:'CLOUD_ENGINE_UNSUPPORTED',status:422});
    return {...raw,captureMode,executionTarget:'local'};
  }
  if (!['efaa', 'pleadings'].includes(code)) return raw;
  const error = message => { throw Object.assign(new Error(message), {code:'INVALID_ENGINE_OPTIONS',status:422}); };
  const companyName = String(raw.companyName || '').trim();
  if (!companyName || companyName.length > 200) error('أدخل اسم الشركة، بحد أقصى 200 حرف.');
  const headerRow = Number(raw.headerRow ?? 1);
  if (!Number.isInteger(headerRow) || headerRow < 0 || headerRow > 100) error('صف العنوان يجب أن يكون من 0 إلى 100.');
  const options = {companyName,headerRow,sheetName:String(raw.sheetName || '').trim().slice(0,31)};
  if(code === 'efaa') {
    options.establishmentNumber = String(raw.establishmentNumber || '').trim().replace(/[٠-٩۰-۹]/g,c=>String('٠١٢٣٤٥٦٧٨٩'.includes(c)?'٠١٢٣٤٥٦٧٨٩'.indexOf(c):'۰۱۲۳۴۵۶۷۸۹'.indexOf(c)));
    if(!/^7\d{9}$/.test(options.establishmentNumber)) error('رقم المنشأة 10 أرقام ويبدأ بـ7؛ ليس رقم الدعوى الموحد.');
    options.inputColumn=Number(raw.inputColumn ?? 1);
    if(!Number.isInteger(options.inputColumn) || options.inputColumn < 1 || options.inputColumn > 16384) error('عمود السند غير صالح.');
  } else {
    options.partyText=String(raw.partyText || '').trim();
    if(!options.partyText || options.partyText.length>5000) error('نص المعترض مطلوب، بحد أقصى 5000 حرف.');
    options.calendar=raw.calendar || 'gregorian';
    options.columnLayout=raw.columnLayout || 'headers';
    if(!['gregorian','hijri'].includes(options.calendar) || !['headers','10','13'].includes(options.columnLayout)) error('تقويم أو ربط أعمدة غير صالح.');
    if(options.headerRow===0 && options.columnLayout==='headers') error('اختر نموذج 10 أو 13 عمودًا للملف دون عناوين.');
  }
  return options;
}
